declare const dataLayer: any[];

import { EVENTS as CartEvents } from './components/bootstrap/cart/bootstrap';

document.addEventListener('DOMContentLoaded', function () {
	(function (CMDDataLayer) {
		// Create a namespace
		CMDDataLayer = CMDDataLayer || {};
	
		// Add properties and methods to the namespace
		CMDDataLayer.user_data = JSON.parse(localStorage.getItem('gtm_user_data'));
	
		CMDDataLayer.user_hashed_data = JSON.parse(localStorage.getItem('gtm_fb_ud'));
		CMDDataLayer.selectors = {
			dlSelector: '#datalyer-common-values',
			//JSON payloads emitted next to server-rendered product lists (see snippets/product-card-gtm-item.liquid)
			productListPayload: 'script[type="application/json"][data-gtm-product-list]'
		};
	
		CMDDataLayer.dataLayerSelector = document.querySelector(CMDDataLayer.selectors.dlSelector);
		if (CMDDataLayer.dataLayerSelector) {
			CMDDataLayer.env = CMDDataLayer.dataLayerSelector.getAttribute('data-env');
			CMDDataLayer.currency = CMDDataLayer.dataLayerSelector.getAttribute('data-currency');
			CMDDataLayer.template = CMDDataLayer.dataLayerSelector.getAttribute('data-template');
			CMDDataLayer.page_path = window.location.pathname;
			CMDDataLayer.page_path_param = window.location.pathname + window.location.search;
	
			CMDDataLayer.query = null;
			CMDDataLayer.item_list_name = 'Site Browse';
			CMDDataLayer.carousel_title = null;
	
			//get content group
			CMDDataLayer.content_group = 'Other';
	
			if (CMDDataLayer.template === 'index') {
				CMDDataLayer.content_group = 'Home';
				CMDDataLayer.carousel_title = 'Our Top Sellers';
				CMDDataLayer.item_list_name = 'Product Carousel';
			} else if (CMDDataLayer.template === '404') {
				CMDDataLayer.content_group = '404 Result';
			} else if (CMDDataLayer.page_path.includes('/search')) {
				CMDDataLayer.content_group = 'Search Product Listing';
				const urlParams = new URLSearchParams(window.location.search);
			CMDDataLayer.query = urlParams.get('query');
				CMDDataLayer.carousel_title = null;
				CMDDataLayer.item_list_name = 'Search Results';
			} else if (CMDDataLayer.template === 'collection') {
				CMDDataLayer.content_group = 'Product Listing';
			} else if (CMDDataLayer.template === 'product') {
				CMDDataLayer.content_group = 'Product Detail';
				CMDDataLayer.carousel_title = 'You may also like...';
				CMDDataLayer.item_list_name = 'Product Carousel';
			} else if (CMDDataLayer.template === 'cart') {
				CMDDataLayer.content_group = 'Cart';
			} else if (CMDDataLayer.template === 'blog' || CMDDataLayer.template === 'article') {
				CMDDataLayer.content_group = 'Blog';
			} else if (CMDDataLayer.page_path.includes('/account')) {
				CMDDataLayer.content_group = 'Account';
			} else if (CMDDataLayer.page_path.includes('/pages/stores')) {
				CMDDataLayer.content_group = 'Stores';
			} else if (CMDDataLayer.page_path.includes('contact')) {
				CMDDataLayer.content_group = 'Contact Us';
			} else if (CMDDataLayer.page_path.includes('/pages/shop-')) {
				CMDDataLayer.content_group = 'Shop by Pages';
			} else if (CMDDataLayer.page_path.includes('/pages/sales-promotions')) {
				CMDDataLayer.content_group = 'Promotions';
			} else if (CMDDataLayer.page_path.includes('/pages/track-your-order')) {
				CMDDataLayer.content_group = 'Order Tracking';
			} else if (CMDDataLayer.page_path.includes('/pages/new-movers')) {
				CMDDataLayer.content_group = 'New Movers';
			} else if (CMDDataLayer.template === 'page') {
				CMDDataLayer.content_group = 'Company Pages';
			}
	
			CMDDataLayer.user_details = [
				{
					log_state: CMDDataLayer.user_data.userId != null ? 'Logged In' : 'Logged Out', // User Account Status | Logged In or Logged Out
					user_id: CMDDataLayer.user_data.userId, // User Account ID
					user_hashed_data: {
						email: CMDDataLayer.user_hashed_data.em,
						phone_number: CMDDataLayer.user_hashed_data.ph,
						first_name: CMDDataLayer.user_hashed_data.fn,
						last_name: CMDDataLayer.user_hashed_data.ln,
						city: CMDDataLayer.user_hashed_data.ct,
						state: CMDDataLayer.user_hashed_data.st,
						zip_code: CMDDataLayer.user_hashed_data.zp,
						country: CMDDataLayer.user_hashed_data.country
					},
					enhanced_conversion: {
						email: CMDDataLayer.user_data.em, // Return the users email address
						phone_number: CMDDataLayer.user_data.ph, // Return the users phone number
						first_name: CMDDataLayer.user_data.fn, // Return the users first name
						last_name: CMDDataLayer.user_data.ln, // Return the users last name
						street: CMDDataLayer.user_data.street, // Return the users street address
						city: CMDDataLayer.user_data.ct, // Return the users City
						state: CMDDataLayer.user_data.st, // Return the users state
						zip_code: CMDDataLayer.user_data.zp, // Return the users postal zip code
						country: CMDDataLayer.user_data.country // Return the users country
					}
				}
			];
	
			//Product added to cart — fires after the cart write + drawer render succeed
			document.addEventListener(CartEvents.ADDED_TO_CART, function (response) {
				CMDDataLayer.PDPATC(response, 'add_to_cart');
			});
	
			//Foundation Added
			document.addEventListener('FoundationWasSelected', function (response) {
				CMDDataLayer.PDPViewItem(response, 'view_item');
			});
	
			//Variant Changed
			document.addEventListener('VariantHasChanged', function (response) {
				CMDDataLayer.PDPViewItem(response, 'view_item');
			});
	
			//View cart — the drawer opens via the #cart-open off-canvas hash (see module.off-canvas)
			CMDDataLayer.viewCartFromHash = function () {
				if (window.location.hash !== '#cart-open') return;
				const cartStore = Alpine.store('shopifyCart');
				if (cartStore && cartStore.cart) {
					CMDDataLayer.cartDataLayer(cartStore.cart, 'view_cart');
				}
			};
			window.addEventListener('hashchange', CMDDataLayer.viewCartFromHash);
			//covers a page that loads with #cart-open already set (Alpine store needs a beat to hydrate)
			setTimeout(CMDDataLayer.viewCartFromHash, 1000);

			//Remove from Cart
			document.addEventListener(CartEvents.ITEM_REMOVED, function (response: CustomEvent) {
				CMDDataLayer.cartDataLayer(response.detail, 'remove_from_cart');
			});
	
			//Contact form submitted
			document.addEventListener('contact-form-submitted', function () {
				CMDDataLayer.generateLeadDataLayer('generate_lead', 'contact_form');
			});
	
			//Footer Newsletter form submitted
			document.addEventListener('newsletter-form-submitted', function () {
				CMDDataLayer.generateLeadDataLayer('generate_lead', 'newsletter_signup');
			});
	
			//GeoLocation Auto Set - Success
			document.addEventListener('geoLocation-auto-set', function (response: CustomEvent) {
				console.log('DL geoLocation-auto-set', response);
				CMDDataLayer.geoLocationDataLayer('Geolocation', 'Auto Set - Success', response.detail);
			});
	
			//GeoLocation Auto Set - Unsuccessful
			document.addEventListener('geoLocation-auto-set-unsuccessful', function (response: CustomEvent) {
				console.log('DL geoLocation-auto-set-unsuccessful', response);
				CMDDataLayer.geoLocationDataLayer('Geolocation', 'Auto Set - Unsuccessful', response.detail);
			});
	
			//GeoLocation Auto Set - Unsuccessful(Wrong Zip)
			document.addEventListener('geoLocation-auto-set-unsuccessful-wrong-zip', function (response: CustomEvent) {
				CMDDataLayer.geoLocationDataLayer('Geolocation', 'Auto Set - Unsuccessful(Wrong Zip)', response.detail);
			});
	
			//GeoLocation Manual Change
			document.addEventListener('geoLocation-manual-change', function (response: CustomEvent) {
				CMDDataLayer.geoLocationDataLayer('Geolocation', 'Manual Change', response.detail);
			});
	
			//GeoLocation Manual Set
			document.addEventListener('geoLocation-manual-set', function (response: CustomEvent) {
				CMDDataLayer.generateLeadDataLayer('Geolocation', 'Manual Set', response.detail);
			});
	
			CMDDataLayer.formatPrice = function (value) {
				return (parseFloat(value) / 100).toFixed(2);
			};
	
			CMDDataLayer.generateUniqueId = function () {
				// Get the current timestamp in milliseconds
				const timestamp = Date.now();
	
				// Get the high-resolution time in microseconds
				const highResTime = performance.now() * 100000000;
	
				// Combine both parts to form a unique ID
				const uniqueId = `${timestamp}-${Math.floor(highResTime)}`;
	
				return uniqueId;
			};
	
			CMDDataLayer.getSelectedPrice = function () {
				const price = CMDDataLayer.selected.price;
				const combo_price = CMDDataLayer.combinationSelected?.price;
				// console.log('getSelectedPrice', price, combo_price);
				return combo_price ? price + combo_price : price;
			};
	
			CMDDataLayer.getSelectedComparePrice = function () {
				const price = CMDDataLayer.selected.price;
				const compare_price = CMDDataLayer.selected.compare_at_price;
				const combo_price = CMDDataLayer.combinationSelected?.price;
				const combo_compare_price = CMDDataLayer.combinationSelected?.compare_at_price;
				// console.log('getSelectedComparePrice', compare_price, combo_compare_price);
				const total_price = CMDDataLayer.getSelectedPrice();
				if (compare_price || combo_compare_price) {
					let total_compare_price = null;
					if (combo_price) {
						total_compare_price =
							(compare_price ? compare_price : price) + (combo_compare_price ? combo_compare_price : combo_price);
					} else {
						total_compare_price = compare_price ? compare_price : price;
					}
					if (total_compare_price && total_compare_price > total_price) {
						return total_compare_price;
					}
				}
				return null;
			};
	
			CMDDataLayer.PDPViewItem = function (response, eventName) {
				if (response.type == 'FoundationWasSelected') {
					CMDDataLayer.combinationSelected = response.detail;
				} else {
					CMDDataLayer.selected = response.detail.variant;
					CMDDataLayer.product = response.detail.product;
					//variant changes reset the PDP addon selections (see product-display.ts)
					CMDDataLayer.combinationSelected = null;
				}
				let m = 0,
					b = parseFloat(CMDDataLayer.formatPrice(CMDDataLayer.getSelectedPrice()));
				CMDDataLayer.getSelectedComparePrice() > 0 &&
					(m = CMDDataLayer.getSelectedComparePrice() - CMDDataLayer.getSelectedPrice());
				let event_details = {
					event_id: CMDDataLayer.generateUniqueId(),
					content_group: CMDDataLayer.content_group,
					currency: CMDDataLayer.currency,
					value: b,
					coupon: void 0
				};
				let E = window['variantStock'][CMDDataLayer.selected.id];
	
				let items = [];
				if (
					CMDDataLayer.combinationSelected != '' &&
					CMDDataLayer.combinationSelected != undefined &&
					response.type == 'FoundationWasSelected'
				) {
					//foundation product discount
					let foundationDiscount = 0;
					if (CMDDataLayer.combinationSelected.compare_at_price > 0) {
						foundationDiscount =
							CMDDataLayer.combinationSelected.compare_at_price - CMDDataLayer.combinationSelected.price;
					}
					//main product discount
					let mainDiscount = 0;
					if (CMDDataLayer.selected.compare_at_price > 0) {
						mainDiscount = CMDDataLayer.selected.compare_at_price - CMDDataLayer.selected.price;
					}
					items.push(
						{
							item_id: Number(CMDDataLayer.product.id),
							item_name: CMDDataLayer.product.title,
							affiliation: 'Shopify Store',
							currency: CMDDataLayer.currency,
							coupon: void 0,
							discount: parseFloat(CMDDataLayer.formatPrice(mainDiscount)),
							index: 0,
							item_brand: CMDDataLayer.product.vendor,
							item_category: CMDDataLayer.product.type,
							item_category2: void 0,
							item_category3: CMDDataLayer.selected.option1,
							item_category4: CMDDataLayer.selected.option2,
							item_category5: CMDDataLayer.selected.option3,
							item_variant: CMDDataLayer.selected.id,
							item_carousel_title: void 0,
							item_list_id: 'Product Detail',
							item_list_name: 'Site Browse',
							location_id: CMDDataLayer.content_group,
							price: parseFloat(CMDDataLayer.formatPrice(CMDDataLayer.selected.price)),
							quantity: 1,
							item_sku: CMDDataLayer.selected.sku,
							item_shopify_id: 'shopify_US_' + CMDDataLayer.product.id + '_' + CMDDataLayer.selected.id,
							item_stock_message: CMDDataLayer.selected.available ? 'In Stock' : 'Out of Stock',
							item_stock_quantity: E
						},
						{
							item_id: Number(CMDDataLayer.product.id),
							item_name: CMDDataLayer.combinationSelected.name,
							affiliation: 'Shopify Store',
							currency: CMDDataLayer.currency,
							coupon: void 0,
							discount: parseFloat(CMDDataLayer.formatPrice(foundationDiscount)),
							index: 1,
							item_brand: CMDDataLayer.product.vendor,
							item_category: CMDDataLayer.product.type,
							item_category2: void 0,
							item_category3: CMDDataLayer.combinationSelected.option1,
							item_category4: CMDDataLayer.combinationSelected.option2,
							item_category5: CMDDataLayer.combinationSelected.option3,
							item_variant: CMDDataLayer.combinationSelected.id,
							item_carousel_title: void 0,
							item_list_id: 'Product Detail',
							item_list_name: 'Site Browse',
							location_id: CMDDataLayer.content_group,
							price: parseFloat(CMDDataLayer.formatPrice(CMDDataLayer.combinationSelected.price)),
							quantity: 1,
							item_sku: CMDDataLayer.combinationSelected.sku,
							item_shopify_id: 'shopify_US_' + CMDDataLayer.product.id + '_' + CMDDataLayer.combinationSelected.id,
							item_stock_message: CMDDataLayer.combinationSelected.available ? 'In Stock' : 'Out of Stock'
						}
					);
				} else {
					items.push({
						item_id: Number(CMDDataLayer.product.id),
						item_name: CMDDataLayer.product.title,
						affiliation: 'Shopify Store',
						currency: CMDDataLayer.currency,
						coupon: void 0,
						discount: parseFloat(CMDDataLayer.formatPrice(m)),
						index: 0,
						item_brand: CMDDataLayer.product.vendor,
						item_category: CMDDataLayer.product.type,
						item_category2: void 0,
						item_category3: CMDDataLayer.selected.option1,
						item_category4: CMDDataLayer.selected.option2,
						item_category5: CMDDataLayer.selected.option3,
						item_variant: CMDDataLayer.selected.id,
						item_carousel_title: void 0,
						item_list_id: 'Product Detail',
						item_list_name: 'Site Browse',
						location_id: CMDDataLayer.content_group,
						price: parseFloat(CMDDataLayer.formatPrice(CMDDataLayer.getSelectedPrice())),
						quantity: 1,
						item_sku: CMDDataLayer.selected.sku,
						item_shopify_id: 'shopify_US_' + CMDDataLayer.product.id + '_' + CMDDataLayer.selected.id,
						item_stock_message: CMDDataLayer.selected.available ? 'In Stock' : 'Out of Stock'
					});
				}
				dataLayer.push({ ecommerce: null });
				dataLayer.push({
					event: eventName,
					ecommerce: {
						event_details: event_details,
						user_details: CMDDataLayer.user_details,
						items: items
					}
				});
			};
	
			CMDDataLayer.PDPATC = function (response, eventName) {
				// detail is the raw /cart/add.js response: { items: [...] }
				CMDDataLayer.productsAdded = response.detail.items || [];
				let eventVal = 0;
				let items = [];
				for (let index = 0; index < CMDDataLayer.productsAdded.length; index++) {
					let item = CMDDataLayer.productsAdded[index];
					eventVal += parseFloat(CMDDataLayer.formatPrice(item.price)) * item.quantity;
					let prodDiscount = 0;
					if (item.extra_variant_compare_at_price != undefined && item.extra_variant_compare_at_price > 0) {
						prodDiscount = item.extra_variant_compare_at_price - item.price;
					}
					items.push({
						item_id: Number(item.product_id),
						item_name: item.product_title,
						affiliation: 'Shopify Store',
						currency: CMDDataLayer.currency,
						coupon: void 0,
						discount: parseFloat(CMDDataLayer.formatPrice(prodDiscount)),
						index: index,
						item_brand: item.vendor,
						item_category: item.product_type,
						item_category2: void 0,
						item_category3: item.variant_options[0],
						item_category4: item.variant_options[1],
						item_category5: item.variant_options[2],
						item_variant: item.id,
						item_carousel_title: void 0,
						item_list_id: 'Product Detail',
						item_list_name: 'Site Browse',
						location_id: 'Product Detail',
						price: parseFloat(CMDDataLayer.formatPrice(item.price)),
						quantity: item.quantity,
						item_sku: item.sku,
						item_shopify_id: 'shopify_US_' + item.product_id + '_' + item.id,
						item_stock_message: 'In Stock',
						item_stock_quantity: null
					});
				}
				let event_details = {
					event_id: CMDDataLayer.generateUniqueId(),
					content_group: CMDDataLayer.content_group,
					currency: CMDDataLayer.currency,
					value: parseFloat(eventVal.toFixed(2)),
					coupon: void 0
				};
				dataLayer.push({ ecommerce: null });
				dataLayer.push({
					event: eventName,
					ecommerce: {
						event_details: event_details,
						user_details: CMDDataLayer.user_details,
						items: items
					}
				});
			};
	
			CMDDataLayer.cartDataLayer = function (t, e) {
				let a = 0;
				let r = {};
				let items = [];
				if (e == 'view_cart') {
					let orderCoupon = '';
					let orderDis = 0;
					if (t.discounts != undefined && t.discounts.length > 0) {
						orderDis = CMDDataLayer.formatPrice(t.discounts[0].amount);
						orderCoupon = t.codes[0];
					}
					a = parseFloat(CMDDataLayer.formatPrice(t.total_price));
					r = {
						event_id: CMDDataLayer.generateUniqueId(),
						content_group: CMDDataLayer.content_group,
						currency: CMDDataLayer.currency,
						value: a,
						coupon: orderCoupon,
						cart_qty: t.item_count,
						discount: orderDis
					};
	
					for (let index = 0; index < t.items.length; index++) {
						let item = t.items[index];
						let prodDiscount = 0;
						if (item.extra_variant_compare_at_price != undefined && item.extra_variant_compare_at_price > 0) {
							prodDiscount = item.extra_variant_compare_at_price - item.price;
						}
						items.push({
							item_id: Number(item.product_id),
							item_name: item.product_title,
							affiliation: 'Shopify Store',
							currency: CMDDataLayer.currency,
							coupon: void 0,
							discount: parseFloat(CMDDataLayer.formatPrice(prodDiscount)),
							index: index,
							item_brand: item.vendor,
							item_category: item.product_type,
							item_category2: void 0,
							item_category3: item.variant_options[0],
							item_category4: item.variant_options[1],
							item_category5: item.variant_options[2],
							item_variant: item.id,
							item_carousel_title: void 0,
							item_list_id: 'Product Detail',
							item_list_name: 'Site Browse',
							location_id: 'Cart',
							price: parseFloat(CMDDataLayer.formatPrice(item.price)),
							quantity: item.quantity,
							item_sku: item.sku,
							item_shopify_id: 'shopify_US_' + item.product_id + '_' + item.id,
							item_stock_message: 'In Stock',
							item_stock_quantity: null
						});
					}
				} else {
					//t is the raw /cart.js line item that was removed
					let removedProdDiscount = 0;
					if (t.extra_variant_compare_at_price != undefined && t.extra_variant_compare_at_price > 0) {
						removedProdDiscount = t.extra_variant_compare_at_price - t.price;
					}
					a = parseFloat(CMDDataLayer.formatPrice(t.price));
					r = {
						event_id: CMDDataLayer.generateUniqueId(),
						content_group: CMDDataLayer.content_group,
						currency: CMDDataLayer.currency,
						value: a,
						coupon: t.discounts ? t.discounts[0] : void 0,
						cart_qty: t.quantity,
						sku_qty: 1
					};
					items = [
						{
							item_id: Number(t.product_id),
							item_name: t.product_title,
							affiliation: 'Shopify Store',
							currency: CMDDataLayer.currency,
							coupon: t.discounts ? t.discounts[0] : void 0,
							discount: parseFloat(CMDDataLayer.formatPrice(removedProdDiscount)),
							index: 0,
							item_brand: t.vendor,
							item_category: t.product_type,
							item_category2: void 0,
							item_category3: t.variant_options ? t.variant_options[0] : void 0,
							item_category4: t.variant_options ? t.variant_options[1] : void 0,
							item_category5: t.variant_options ? t.variant_options[2] : void 0,
							item_variant: t.id,
							item_carousel_title: void 0,
							item_list_id: 'Product Detail',
							item_list_name: 'Site Browse',
							location_id: 'Cart',
							price: parseFloat(CMDDataLayer.formatPrice(t.price)),
							quantity: 0,
							item_sku: t.sku,
							item_shopify_id: 'shopify_US_' + t.product_id + '_' + t.id,
							item_stock_message: 'In Stock',
							item_stock_quantity: null
						}
					];
				}
				dataLayer.push({ ecommerce: null });
				dataLayer.push({
					event: e,
					ecommerce: {
						event_details: r,
						user_details: CMDDataLayer.user_details,
						items: items
					}
				});
			};
	
			CMDDataLayer.generateLeadDataLayer = function (eventName, leadType) {
				dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
				dataLayer.push({
					event: eventName,
					ecommerce: {
						event_details: {
							event_id: CMDDataLayer.generateUniqueId(), // Unique Event ID
							lead_type: leadType, // “contact_form” or “newsletter_signup”
							lead_id: 'Lead-' + CMDDataLayer.generateUniqueId() // unique identifier for each lead to track individual leads
						},
						user_details: CMDDataLayer.user_details
					}
				});
			};
	
			CMDDataLayer.pageLoadedDataLayer = function (eventName) {
				//pageload datalayer
				dataLayer.push({ page_details: null }); // Clear the previous ecommerce object.
				dataLayer.push({
					event: eventName,
					// EVENT LEVEL DATA OBJECT
					page_details: {
						environment: CMDDataLayer.env, // Staging or Production
						page_path: CMDDataLayer.page_path, // Page Path
						page: CMDDataLayer.page_path_param, // Full Page Path
						content_group: CMDDataLayer.content_group, // Page Type
						event_id: CMDDataLayer.generateUniqueId(), // Unique Event ID
						user_details: CMDDataLayer.user_details
					}
				});
			};
	
			//page loaded
			CMDDataLayer.pageLoadedDataLayer('page_loaded');
	
			//items registered from product-list payloads, keyed by product id (powers select_item)
			CMDDataLayer.listItems = {};
	
			CMDDataLayer.getProductItem = function (item, listName) {
				//item is one entry of a data-gtm-product-list payload (prices in cents)
				let productTitle = item.title;
				let productVendor = item.vendor;
				let productPrice = CMDDataLayer.formatPrice(item.price);
				let productComparePrice = CMDDataLayer.formatPrice(item.compare_at_price);
				let productId = item.id;
				let productSku = item.sku;
				let productAvailable = item.available;
				let productInventoryQty = item.inventory_quantity;
				let productVariantID = item.variant_id;
				let productOption1 = item.option1 || null;
				let productOption2 = item.option2 || null;
				let productOption3 = item.option3 || null;
				let productType = item.type;
				let productPosition = item.position;
				let productListName = listName || CMDDataLayer.item_list_name;
	
				let discount = 0;
				if (parseFloat(productComparePrice) > parseFloat(productPrice)) {
					discount = parseFloat(productComparePrice) - parseFloat(productPrice);
				}
				let gaItem = {
					item_id: Number(productId), // Parent Sku
					item_name: productTitle, // Product Name (w/o variant info)
					affiliation: 'Shopify Store', // Segment
					currency: CMDDataLayer.currency, // Product Currency Code
					coupon: undefined, // Product Level Coupon/Promo
					discount: parseFloat(discount.toFixed(2)), // Product Level Discount for Sale items
					index: Number(productPosition), // Product Click Position in List
					item_brand: productVendor, // Product Brand
					item_category: productType, // Product Type
					item_category2: null, // (Review Available Data)
					item_category3: productOption1, // Product Size | Option 1
					item_category4: productOption2, // Product Color | Option 2
					item_category5: productOption3, // Option 3
					item_variant: Number(productVariantID), // Product Variant ID
					item_carousel_title: CMDDataLayer.carousel_title, // Original View / Click Product List Carousel Title
					item_list_id: CMDDataLayer.content_group, // Original View / Click Page Type
					item_list_name: productListName, // Site Browse, Product Carousel, or Search Results
					location_id: CMDDataLayer.content_group, // Current Page Type | Event Location
					price: parseFloat(productPrice), // Product Price | Actual Selling Price
					quantity: 1, // Quantity set to 1
					item_sku: productSku, // Product Sku
					item_shopify_id: 'shopify_US_' + productId + '_' + productVariantID + '', // Full Sku (Parent + Variant)
					item_stock_message: productAvailable ? 'In Stock' : 'Out of Stock', // In Stock
					item_stock_quantity: productInventoryQty != undefined ? productInventoryQty : null
				};
				return gaItem;
			};
	
			CMDDataLayer.processProductList = function (payload) {
				if (!payload || !payload.items || payload.items.length === 0) {
					return;
				}
				if (payload.searchTerm) {
					CMDDataLayer.query = payload.searchTerm;
				}
				if (payload.resultCount != undefined) {
					window['search_result_count'] = payload.resultCount;
				}

				let gaItems = payload.items.map(function (item) {
					let gaItem = CMDDataLayer.getProductItem(item, payload.listName);
					CMDDataLayer.listItems[String(item.id)] = gaItem;
					return gaItem;
				});

				//push in pages of 20, mirroring the legacy behavior
				for (let offset = 0; offset < gaItems.length; offset += 20) {
					dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
					dataLayer.push({
						event: 'view_item_list',
						ecommerce: {
							event_details: {
								event_id: CMDDataLayer.generateUniqueId(), // Unique Event ID
								content_group: CMDDataLayer.content_group, // Page Type
								currency: CMDDataLayer.currency, // Currency Code
								search_term: CMDDataLayer.query, // Search term (when applicable)
								count_of_search_results: window['search_result_count'] // Search Result count (when applicable)
							},
							user_details: CMDDataLayer.user_details,
							items: gaItems.slice(offset, offset + 20)
						}
					});
				}
			};

			//server-rendered lists (collection, search) announce themselves via JSON payloads…
			document.querySelectorAll(CMDDataLayer.selectors.productListPayload).forEach(function (payloadEl) {
				try {
					CMDDataLayer.processProductList(JSON.parse(payloadEl.textContent));
				} catch (error) {
					console.error('DL invalid product list payload', error);
				}
			});

			//…async lists (recommendations) dispatch the same payload once rendered
			document.addEventListener('ProductListRendered', function (response: CustomEvent) {
				CMDDataLayer.processProductList(response.detail);
			});

			//select_item — one delegated listener; cards render as #ProductCard-<productId>
			document.addEventListener('click', function (event) {
				if (!(event.target instanceof Element)) {
					return;
				}
				let card = event.target.closest('[id^="ProductCard-"]');
				if (!card) {
					return;
				}
				let item = CMDDataLayer.listItems[card.id.replace('ProductCard-', '')];
				if (item) {
					CMDDataLayer.selectItemDataLayer(item, 'select_item');
				}
			});
	
			CMDDataLayer.selectItemDataLayer = function (item, eventName) {
				let event_details = {
					event_id: CMDDataLayer.generateUniqueId(),
					content_group: CMDDataLayer.content_group,
					currency: CMDDataLayer.currency,
					value: item.price,
					coupon: void 0,
					search_term: CMDDataLayer.query, // Search term (when applicable)
					count_of_search_results: window['search_result_count'] // Search Result count (when applicable)
				};
				dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
	
				dataLayer.push({
					event: eventName,
					ecommerce: {
						event_details: event_details,
						user_details: CMDDataLayer.user_details,
						items: [item]
					}
				});
			};
	
			CMDDataLayer.geoLocationDataLayer = function (eventName, eventType, response) {
				dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
				dataLayer.push({
					event: eventName,
					ecommerce: {
						event_details: {
							event_id: CMDDataLayer.generateUniqueId(), // Unique Event ID
							type: eventType, // Type of the geolocation setup: Auto Set Unsuccessful/Success and Manual Set/Change
							location: response.store.name, // Location select from the user
							previousLocation: response.oldStore ? response.oldStore?.name : 'N/A', // In case that the user change the location appoint the last one
							state: response.store.state // State attached to the location seleted
						},
						user_details: CMDDataLayer.user_details
					}
				});
			};
		}
	})();
	
});